import axios from 'axios';

const apiUrl = process.env.REACT_APP_HERO_LAMBDA;

const heroSlidesApi = {
  postHeros: (data) => axios.post(apiUrl, data),
};

export default heroSlidesApi;
